import { IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/EmailTwoTone';
import styles from './ApplicationLink.module.css';

interface MailLinkProps {
  emailAddress: string;
  showIcon?: boolean;
  title?: string;
}

/**
 * Component for rendering an Email Address link.
 */
export default function MailLink(props: MailLinkProps) {
  if (props.showIcon)
    return (
      <IconButton
        className={styles['icon-btn']}
        href={`mailTo:${props.emailAddress}`}
        disabled={!props.emailAddress}
        title={props.title ? props.title : props.emailAddress}>
        <EmailIcon fontSize='inherit' />
      </IconButton>
    );
  else
    return (
      <a
        href={`mailto:${props.emailAddress}`}
        className={styles.link}
        title={props.emailAddress}>
        {props.emailAddress}
      </a>
    );
}
